/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { PRICE_MAGNITUDE } from '../constants';

export const formatPrice = (value = 0) => `$${(value / PRICE_MAGNITUDE).toFixed(2)}`;
